import api from '../../api/projects'
import { LIST_PROJECT, LIST_PROJECTS, ADD_PROJECT, UPDATE_PROJECT, GET_CATEGORIES, LIST_PROJECT_FILES, ADD_PROJECT_FILES } from '../types'

export const listProjects = () => async dispatch => {
  const results = await api.get('/projects')
  dispatch({ type: LIST_PROJECTS, payload: results.data })
}

export const listProject = id => async dispatch => {
  const project = await api.get(`/projects/${id}`)

  dispatch({ type: LIST_PROJECT, payload: project.data })
}
export const addProject = (data) => async dispatch => {
  const project = await api.post(`/projects`, { data })
  dispatch({ type: ADD_PROJECT, payload: project.data })
}
export const updateProject = (id, data) => async dispatch => {
  const project = await api.patch(`/projects/${id}`, { data })
  // dispatch({ type: UPDATE_PROJECT, payload: project.data })
}

export const listProjectFiles = id => async dispatch => {
  const project = await api.get(`/projects/${id}/files`)
  dispatch({ type: LIST_PROJECT_FILES, payload: project.data })
}

export const addFilesToProject = (id, data) => async dispatch => {
  const project = await api.patch(`/projects/${id}/files`, { data })
  dispatch({ type: ADD_PROJECT_FILES, payload: project.data })
}

export const getCategories = () => async dispatch => {
  const categories = await api.get(`/categories`)

  dispatch({ type: GET_CATEGORIES, payload: categories.data })
}

export const inviteCollaborators = (id, data) => async dispatch => {
  const project = await api.post(`/projects/${id}/inviteCollaborator`, { data })
  console.log(project.data)
  // dispatch({ type: UPDATE_PROJECT, payload: project.data })
}